import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { UserActivityAxios } from "../../API";

export default function ImportantLinks() {
  const history = useHistory();
  const importantLinks = useSelector(
    (state) => state.auth.missionDetails.quickLinks
  );
  const links = [...importantLinks];

  const userDetails = useSelector((state) => state.auth.loggedInUser);

  const openLink = (item) => {

    var UAdata = {
      email: userDetails.email,
      offeringId: userDetails.offeringId,
      missionId: userDetails.missionId,
      userId: userDetails.userId,
      offeringUserId: userDetails.offeringUserId,
      actionType: "Quick Links",
      actionName: item.name,
      actionOn: item.action,
    };
    UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

    }).catch(function (error) {
      console.log(error);
    });
    if (item.target.toLowerCase() == "_self") {
      history.push(item.action);
    } else {
      window.open(item.action, item.target);
    }
  };
  let minHeight = links.length > 5 ? "230px" : links.length * 36 + 20;
  return (
    links.length > 0 && (
      <>
        <div className="important-links-header">
          <div className="left-right-border"></div>
          <div className="important-links-title">Important Links</div>
        </div>
        <div className="important-links scroll-content" style={{ minHeight }}>
          {links.map((item) => {
            return (
              <div
                key={item.name}
                className="important-link"
                onClick={() => {
                  openLink(item);
                }}
              >
                <div>{item.name}</div>
                <div className="important-link-arrow"></div>
              </div>
            );
          })}
        </div>
        <div className="important-links-footer">
          <div className="important-links-footer-border"></div>
        </div>
      </>
    )
  );
}
